// Test IDs for Sam Makeover Academy
export const HOME = {
  emergentLink: 'home-emergent-link',
  
  // Navigation
  navHome: 'home-nav-link',
  navAbout: 'about-nav-link',
  navCourses: 'courses-nav-link',
  navGallery: 'gallery-nav-link',
  navReviews: 'reviews-nav-link',
  navContact: 'contact-nav-link',
  navAdmin: 'admin-dashboard-nav-link',

  // Hero Actions
  heroEnrollBtn: 'hero-enroll-now-btn',
  heroCallBtn: 'hero-call-now-btn',

  // WhatsApp Floating Button & Instagram
  whatsappFab: 'whatsapp-fab-button',
  instagramBtn: 'instagram-social-button',

  // Form Fields
  formNameInput: 'enroll-name-input',
  formEmailInput: 'enroll-email-input',
  formPhoneInput: 'enroll-phone-input',
  formCourseSelect: 'enroll-course-select',
  formMessageTextarea: 'enroll-message-textarea',
  formSubmitBtn: 'enroll-submit-btn',
  formSuccessMessage: 'enroll-success-message',

  // AI Chat Assistant
  chatToggleBtn: 'chat-assistant-toggle',
  chatInput: 'chat-assistant-input',
  chatSendBtn: 'chat-assistant-send-btn',
  chatWindow: 'chat-assistant-window',
  chatMessage: 'chat-assistant-message',

  // Admin Lead Viewer
  adminLoginSection: 'admin-login-section',
  adminPasswordInput: 'admin-password-input',
  adminLoginBtn: 'admin-login-btn',
  adminDashboard: 'admin-dashboard-panel',
  leadRow: 'admin-lead-row',
  leadDeleteBtn: 'admin-lead-delete-btn',
  leadStatusSelect: 'admin-lead-status-select',
};
